import { ActionTree } from "vuex";
import { RootState } from "../types";
import { TalentsState } from "./types";

export const actions: ActionTree<TalentsState, RootState> = {
  setTalentIds({ commit }, ids) {
    commit("SET_IDS", ids);
  },
};
